import { render, staticRenderFns } from "./CreditDebitDetail.vue?vue&type=template&id=5c653ef9&scoped=true&"
import script from "./CreditDebitDetail.vue?vue&type=script&lang=js&"
export * from "./CreditDebitDetail.vue?vue&type=script&lang=js&"
import style0 from "./CreditDebitDetail.vue?vue&type=style&index=0&id=5c653ef9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c653ef9",
  null
  
)

export default component.exports